var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartIconDouble = function SvgHeartIconDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heartIconDouble_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M10.643 19.35a.5.5 0 0 0 .714 0l8.426-8.617c2.289-2.34 2.29-6.127.002-8.468A5.75 5.75 0 0 0 15.627.5a5.8 5.8 0 0 0-4.173 1.764l-.47.48-.467-.477v-.002A5.75 5.75 0 0 0 6.357.5a5.7 5.7 0 0 0-4.144 1.767c-2.286 2.34-2.285 6.127.003 8.466z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heartIconDouble_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v20H0z"
  })))));
};
export default SvgHeartIconDouble;